/* eslint-disable no-magic-numbers */
import React from 'react';
import '@/components/FunctionalArea/Modal/EditElementModal/EditElementModal.styles.css';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { reactionMetaStateSelector } from '@/redux/modal/modal.selector';
import { reactionsByModelIdSelector } from '@/redux/reactions/reactions.selector';
import { ReactionPropertiesForm } from '@/components/FunctionalArea/Modal/EditReactionModal/ReactionPropertiesForm.component';
import { ReactionPreviewPanel } from '@/components/FunctionalArea/Modal/EditReactionModal/ReactionPreviewPanel.component';

export const EditReactionModal: React.FC = () => {
  const reactionMetaState = useAppSelector(reactionMetaStateSelector);
  const reactions = useAppSelector(state =>
    reactionsByModelIdSelector(state, reactionMetaState?.model || 0),
  );

  if (!reactionMetaState) {
    throw new Error('Invalid reaction');
  }

  const reaction = reactions.find(item => item.id === reactionMetaState.id);

  return (
    <div className="relative flex w-[800px] flex-1 flex-col overflow-hidden border border-t-[#E1E0E6] bg-white p-[24px]">
      <ReactionPreviewPanel reaction={reaction} />
      <div className="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto pt-4">
        <ReactionPropertiesForm />
      </div>
    </div>
  );
};
